export const MatchupLineUpHeaderSkeleton = () => {
	return (
		<div className="space-y-6">
			<div className="flex flex-col sm:flex-row sm:justify-between printable">
				<div className="w-full">
					<div className="hidden sm:block">
						<div className="flex justify-between">
							<div>
								<div className="flex items-center gap-20">
									<div className="h-4 w-28 bg-gray-200 animate-pulse rounded" />
								</div>

								<div className="my-4 space-y-2">
									<div className="flex items-center gap-4">
										<div className="h-4 w-32 bg-gray-200 animate-pulse rounded" />
									</div>
									<div className="flex items-center gap-4">
										<div className="h-4 w-32 bg-gray-200 animate-pulse rounded" />
									</div>
								</div>

								<div className="mt-2 flex items-center gap-2">
									<div className="h-4 w-16 bg-gray-200 animate-pulse rounded" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
